import { LayerModule } from './.LayerModule';
import ApiLayersMap from '../WebApiModules/ApiLayersMap.js';

export class PipelineLayerModule extends LayerModule {
    async OpenLayer(callback) {
        return new Promise((rs)=>{
            ApiLayersMap.ListLayerInfo(
                { FolderFullName: this.layerInfo.FolderFullName, Name: this.layerInfo.Name },
                (obj) => {
                    console.log(obj);
                    let result = obj.result;
                    this.oviewLayer = window.gMainMap.TerrainView.addPipelineLayer({
                        url: window.gMainMap.OviewMapServerUrlUnderProxy(),
                        urlTemplate: result.URLTemplate || window.gMainMap.ProxyUrlTemplete(),
                        identifier: result.ID,
                        callback: (success, modelSetLayer) => {
                            if (success) {

                                rs({ success: success, layer: modelSetLayer });
                            }
                            else {
                                rs({ success: success, layer: modelSetLayer });
                            }
                        },
                    });
                },
                () => {
                    console.error(`取得${this.layerInfo.FolderFullName}/${this.layerInfo.Name}圖層資訊失敗`)
                }
            )
        }).then((param)=>{
            console.log(param);
            this.oviewLayer = param.layer;
            if (param.message === "duplicate name exists") { // 如果只是名稱重複當作成功
                this.oviewLayer = window.gMainMap.TerrainView.findLayer(this.layerInfo.Name);
                param.success = true;
            }
            // 有參考的圖層到都加進去
            window.gMainMap.TerrainView.openedLayerStack.push(this.oviewLayer.name);
            callback && callback(param);
            return param.success;
        }, ()=>{ //fail
            return false;
        });
    }
}